import { Divider } from "antd";

const Alyglo = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">
          INDICATION
        </p>

        <p className="m-2">
          ALYGLO™ is indicated for the treatment of primary humoral immunodeficiency (PI) in adults aged 17 years and
          older. This includes, but is not limited to, congenital agammaglobulinemia, common variable immunodeficiency
          (CVID), Wiskott-Aldrich syndrome, and severe combined immunodeficiencies.
        </p>

        <p className="m-2 font-bold">
          IMPORTANT SAFETY INFORMATION
        </p>

        <div className="m-2 border border-black p-2 font-bold">
          <p className="m-2">WARNING: THROMBOSIS, RENAL DYSFUNCTION and ACUTE RENAL FAILURE</p>
          <ul className="list-disc ml-4">
            <li className="m-2">Thrombosis may occur with immune globulin intravenous (IGIV) products, including ALYGLO.
              Risk factors may include: advanced age, prolonged immobilization, hypercoagulable conditions, history of
              venous or arterial thrombosis, use of estrogens, indwelling vascular catheters, hyperviscosity, and
              cardiovascular risk factors.
            </li>
            <li className="m-2">Renal dysfunction, acute renal failure, osmotic nephropathy, and death may occur with
              the administration of IGIV products in predisposed patients.
            </li>
            <li className="m-2">Renal dysfunction and acute renal failure occur more commonly in patients receiving IGIV
              products containing sucrose. ALYGLO does not contain sucrose.
            </li>
            <li className="m-2">For patients at risk of thrombosis, renal dysfunction or renal failure, administer
              ALYGLO at the minimum dose and infusion rate practicable. Ensure adequate hydration in patients before
              administration. Monitor for signs and symptoms of thrombosis and assess blood viscosity in patients at
              risk for hyperviscosity.
            </li>
          </ul>
        </div>

        <ul className="m-2 list-disc ml-10 mt-6">
          <li className="m-2">
            <b>Contraindications: </b>
            ALYGLO is contraindicated in patients who have a history of anaphylactic or severe systemic reaction to the
            administration of human immune globulin and in IgA-deficient patients with antibodies to IgA and a history
            of hypersensitivity.
          </li>
          <li className="m-2">
            <b>Hypersensitivity: </b>
            In case of hypersensitivity, discontinue infusion immediately and institute appropriate treatment.
            Epinephrine should be available for immediate treatment of severe acute hypersensitivity reactions.
          </li>
          <li className="m-2">
            <b>Hyperproteinemia, Increased Serum Viscosity, and Hyponatremia: </b>
            Hyperproteinemia, increased serum viscosity, and hyponatremia may occur.
          </li>

          <li className="m-2">
            <b>Aseptic Meningitis Syndrome (AMS): </b>
            Aseptic meningitis syndrome (AMS) may occur, especially with high doses or rapid infusion. AMS usually
            begins within several hours to 2 days following ALYGLO treatment. Discontinuation of treatment has resulted
            in remission of AMS within several days without sequelae.
          </li>

          <li className="m-2">
            <b>Hemolysis: </b>
            Delayed hemolytic anemia due to enhanced red blood cell (RBC) sequestration and acute hemolysis consistent with intravascular hemolysis have been reported. Cases of severe hemolysis-related renal dysfunction/failure or disseminated intravascular coagulation have occurred following infusion of IGIV. Closely monitor patients for clinical signs and symptoms of hemolysis, particularly patients with risk factors.
          </li>

          <li className="m-2">
            <b>Transfusion-Related Acute Lung Injury: </b>
            Noncardiogenic pulmonary edema (transfusion-related acute lung injury [TRALI]) may occur. TRALI is characterized by severe respiratory distress, pulmonary edema, hypoxemia, normal left ventricular function, and fever. Patients with TRALI may be managed using oxygen therapy with adequate ventilator support. Monitor patients for pulmonary adverse reactions.
          </li>

          <li className="m-2">
            <b>Transmissible Infectious Agents: </b>
            Because ALYGLO is made from human blood, it may carry a risk of transmitting infectious agents (eg, viruses, the variant Creutzfeldt-Jakob disease [vCJD] agent and, theoretically, the Creutzfeldt-Jakob disease [CJD] agent).
          </li>

          <li className="m-2">
            <b>Interference with Laboratory Tests: </b>
            After infusion of immunoglobulin, the transitory rise of the various passively transferred antibodies in the patient’s blood may yield positive serological testing results, with the potential for a misleading interpretation.
          </li>

          <li className="m-2">
            <b>Adverse reactions (observed in ≥ 5% of study subjects) were headache, nausea/vomiting, fatigue, nasal/sinus congestion, rash, arthralgia, diarrhea, muscle pain/aches, infusion site pain/swelling, abdominal pain/discomfort, cough, and dizziness.
            </b>
          </li>

          <li className="m-2">
            <b>It is recommended that ALYGLO be administered separately from other drugs or medications.
            </b>
          </li>
        </ul>

        <div>
          <p className="m-2">
            <b>
              For more information about ALYGLO, please see full&nbsp;
              <a
                target="_blank"
                href="/Alyglo-Prescribing-Information.pdf"
                className="text-blue-500 hover:underline"
              >
                Prescribing Information
              </a>
            </b>
          </p>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of prescription drugs to GC BioPharma USA. Email&nbsp;
              <a
                href="mailto:medicalinfo@gcbiopharmausa.com"
                className="text-blue-500 hover:underline"
              >
                medicalinfo@gcbiopharmausa.com
              </a>
              &nbsp;or call 1-833-426-6426
            </b>
          </p>
        </div>

      </div>
    </>
  );
};

export default Alyglo;
